import React, { useState, useContext } from "react";
import "./style.css";
import { NavLink } from "react-router-dom";
import packageInfo from '../../../../package.json';
import LeftNavLink from "components/common/LeftNavLink";
import { CompanyContext } from "lib/context/CompanyContext";
import { UserContext } from "lib/context/UserContext";
import { MIGRATIONS_ACCESS_USERS } from "components/account/Login";

function NavSection({ title, children, defaultOpen = true }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className="nav-section">
      <button className="nav-section__header" onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <svg
          className={`nav-section__chevron ${isOpen ? "nav-section__chevron--open" : ""}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {isOpen && <div className="nav-section__items">{children}</div>}
    </div>
  );
}

export default function LeftNav() {
  const { company } = useContext(CompanyContext);
  const { user } = useContext(UserContext);
  const isMigrationsOnly = MIGRATIONS_ACCESS_USERS.includes((user?.email || "").toLowerCase());
  const isJohnWelch = user?.email === "johnwelch@deltek.com";

  return (
    <div className="app-body__left-nav">
      <div className="nav-header">
        <span className="nav-header__brand">ComputerEase</span>
        <span className="nav-header__title">Support Portal</span>
      </div>

      <div className="nav-sections">
        <NavSection title="ComputerEase Desktop">
          {!isMigrationsOnly && (
            <NavLink to="/notifications">
              <LeftNavLink linkLabel="Notifications" />
            </NavLink>
          )}
          <NavLink to="/data-syncs">
            <LeftNavLink linkLabel="Cloud Migrations" />
          </NavLink>
          {isJohnWelch && (
            <NavLink to="/websockets">
              <LeftNavLink linkLabel="Websocket Connections" />
            </NavLink>
          )}
        </NavSection>

        <NavSection title="API Data">
          <NavLink to="/clients">
            <LeftNavLink linkLabel="Clients" />
          </NavLink>
          {!isMigrationsOnly && (
            <>
              <NavLink to="/companies">
                <LeftNavLink linkLabel="Companies" />
              </NavLink>
              <NavLink to="/users">
                <LeftNavLink linkLabel="Users" />
              </NavLink>
              <NavLink to="/groups">
                <LeftNavLink linkLabel="Groups" />
              </NavLink>
              <NavLink to="/roles">
                <LeftNavLink linkLabel="Roles" />
              </NavLink>
              <NavLink to="/conversation-feedback">
                <LeftNavLink linkLabel="Dela Conversations" />
              </NavLink>
            </>
          )}
        </NavSection>

        {!company.uuid && !isMigrationsOnly && (
          <NavSection title="Settings">
            {isJohnWelch && (
              <NavLink to="/rename_employees">
                <LeftNavLink linkLabel="Employee Rename" />
              </NavLink>
            )}
            <NavLink to="/support/users">
              <LeftNavLink linkLabel="System Admins" />
            </NavLink>
          </NavSection>
        )}
      </div>

      <div className="spacer"></div>
      <div className="version-info">{packageInfo.version}</div>
    </div>
  );
}
